/** Keep in sync with server/settlement-formulas.js */

export function formatRatePercent(rate: number | null | undefined): string | null {
  const n = Number(rate);
  if (!Number.isFinite(n)) return null;
  const percent = Math.round(n * 1000) / 10;
  if (!Number.isFinite(percent)) return null;
  return Number.isInteger(percent) ? String(percent) : percent.toFixed(1);
}

export function platformCommissionPhrase(rate = 0.15): string {
  return `${formatRatePercent(rate) || formatRatePercent(0.15)}%`;
}

export function settlementFormulaLegendRows(
  platformCommissionPct = 0.15,
  layout?: {
    firstDataRow?: number;
    letters?: Record<string, string>;
  }
): string[][] {
  const rate = platformCommissionPhrase(platformCommissionPct);
  const row = layout?.firstDataRow || 10;
  const letters = layout?.letters || {
    gross: 'C',
    service: 'I',
    platform: 'J',
    performance: 'K',
    marketing: 'L',
    issues: 'M',
    deductions: 'N',
  };
  const deductionsFormula = `=${letters.service}${row}+${letters.platform}${row}+${letters.performance}${row}+${letters.marketing}${row}+${letters.issues}${row}`;
  const netFormula = `=${letters.gross}${row}-${letters.deductions}${row}`;
  return [
    ['Formulas'],
    [],
    ['Line', 'Formula'],
    [
      `Platform commission (${rate})`,
      `${rate} × merchandise subtotal of completed orders (drinks/food before tax, service, and delivery). Per order: merchandise × ${rate.replace('%', '')} / 100. Café total is the sum. This is not the dine-in commission.`,
    ],
    [
      'Service fees',
      '0.20 JOD × completed orders (flat settlement service line, not the customer checkout service %).',
    ],
    [
      'Performance fee',
      'Sum of the campaign performance add-on (JOD per redeemed order) for orders that used a campaign with that add-on. 0 if the order had no such campaign.',
    ],
    [
      'Marketing owed',
      'Daily rate × days the promo overlaps this week. Campaign = plan daily rate (feed or homepage). Offer = (setup fee per month ÷ 30) × days.',
    ],
    [
      'Issue adjustments',
      'Sum of café deductions from approved issue refunds in this period.',
    ],
    [
      'Dine-in commission (recorded, not collected)',
      'Sum of dine_in_commission_jod on completed dine-in orders. Separate from platform commission. Recorded for later. Not added to total deductions and not taken off the net bank transfer until card payments collect it.',
    ],
    [
      'Total deductions',
      'Platform commission + Service fees + Performance fee + Marketing owed + Issue adjustments. Dine-in commission is not included.',
    ],
    [
      'Net payable',
      'Gross via platform − Total deductions',
    ],
    [
      'Platform est. margin',
      'Platform commission + Service fees + Performance fee + Marketing owed + Delivery fee kept by QahwaHub. Café refund deductions are not QahwaHub profit.',
    ],
    [
      'Delivery fee',
      'Customer delivery fee. DELIVERY_FEE_RECIPIENT=platform (default) keeps it for QahwaHub and leaves it out of café gross and the net bank transfer. DELIVERY_FEE_RECIPIENT=cafe gives it to the café.',
    ],
    [],
    ['Summary sheet (first café row)'],
    ['Total deductions', deductionsFormula],
    ['Net payable', netFormula],
    [
      'Platform est. margin',
      'Platform commission total + Service fees + Performance add-on + Marketing owed + Delivery fee (QahwaHub). Not issue adjustments.',
    ],
  ];
}
